import { fetchList } from './utils'

export const fetchPerformances = (page, filters, limit, language, userToken) => {
  if (!filters.ordering) filters.ordering = 'artist__name' // eslint-disable-line
  return fetchList(page, filters, 'performances_lite', limit, language, userToken)
}
